import React, { Component } from "react";

import { Button, Modal, Popconfirm } from "antd";
import { Tabs } from "antd";
import { message } from "antd";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import instance from "@/store/actions/instance";
import TransferOrderInvoice from "./TransferOrderInvoice";

const { TabPane } = Tabs;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

class TransferOrderDetailsModal extends Component {
  state = {
    loading: true,
    products: [],
    editMode: false,
    originalProducts: [],

    isReceiving: false,
  };

  setProducts = (newProducts) => {
    this.setState({ products: newProducts });
  };

  updateTransferOrderStatus = async (newStatus) => {
    const { t, selectedOrder } = this.props;
    const { products } = this.state;
    try {
      this.setState({ loading: true });

      const res = await instance.post(`change_transfer_order_status/`, {
        oid: selectedOrder.id,
        newStatus: newStatus,
        type: "status",
        products,
      });
      selectedOrder.status = res.data;
      message.success(t("Changed successfully"));
      await this.fetchTransferOrderDetails();
      this.setState({
        loading: false,
        isReceiving: false,
      });
    } catch (err) {
      this.setState({
        loading: false,
      });
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(err.response?.data?.error || t("SomethingWentWrong"));
    }
  };
  fetchTransferOrderDetails = async () => {
    const { t, selectedOrder } = this.props;
    try {
      const res = await instance.get(`get_transfer_orders/${selectedOrder.id}`);

      this.setState({
        loading: false,
        products: res.data,
        originalProducts: JSON.parse(JSON.stringify(res.data)),
      });
    } catch (err) {
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    }
  };
  setEditMode = (newEditMode) => {
    this.setState({ editMode: newEditMode });
  };

  setLoading = (newLoading) => {
    this.setState({ loading: newLoading });
  };
  componentDidMount = () => {
    this.fetchTransferOrderDetails();
  };

  updateTransferOrder = async () => {
    const { t, selectedOrder } = this.props;
    const { products } = this.state;
    try {
      this.setState({ loading: true });

      const res = await instance.post(`update_transfer_order/`, {
        orderId: selectedOrder.id,
        products: products,
      });

      this.fetchTransferOrderDetails();
      this.setState({
        loading: false,
        editMode: false,
        // originalProducts: products,
      });
      message.success(t("Changed successfully"));
    } catch (err) {
      this.setState({
        loading: false,
      });
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(err.response?.data?.error || t("SomethingWentWrong"));
    }
  };
  render() {
    const { t, config, selectedOrder, permissions, isViewOnly } = this.props;
    const { loading, products, editMode, originalProducts, isReceiving } =
      this.state;

    const hassPermissionToReceive =
      permissions.all_permitted_branches.findIndex(
        (b) => b.id === selectedOrder.to_branch_id,
      ) !== -1;

    return (
      <Modal
        maskClosable={false}
        destroyOnClose={true}
        title={
          <div
            className="ant-modal-title"
            style={{ textAlign: config.direction == "rtl" ? "right" : "left" }}
          >
            {t("Order details")}
          </div>
        }
        open={true}
        cancelText={t("Close")}
        okButtonProps={{
          style: {
            display: "none",
          },
        }}
        bodyStyle={{
          paddingTop: 0,
          width: "auto",
          textAlign: config.direction == "ltr" ? "left" : "right",
        }}
        width={580}
        onCancel={this.props.onClose}
        footer={[
          !loading && !isViewOnly && (
            <>
              {!editMode ? (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {permissions.can_create_transfer_orders && (
                    <Button
                      onClick={() =>
                        this.props.duplicateOrder({
                          products: products,
                          order: selectedOrder,
                        })
                      }
                      style={{
                        margin: 5,
                      }}
                    >
                      {t("Duplicate Transfer")}
                    </Button>
                  )}
                  {permissions.can_update_transfer_orders &&
                    selectedOrder.status !== "Cancelled" && (
                      <div>
                        {selectedOrder.status == "New" && (
                          <>
                            <Button
                              type="danger"
                              onClick={() =>
                                this.updateTransferOrderStatus("Cancelled")
                              }
                              style={{ margin: "5px" }}
                            >
                              {t("Cancel")}
                            </Button>
                            <Button
                              type="primary"
                              onClick={() =>
                                this.updateTransferOrderStatus("Sent")
                              }
                              style={{ margin: "5px" }}
                            >
                              {t("Send Transfer")}
                            </Button>
                          </>
                        )}

                        {["Sent", "Partial"].includes(selectedOrder.status) &&
                          !isReceiving && (
                            <div>
                              {selectedOrder.status === "Partial" && (
                                <Popconfirm
                                  title={t(
                                    "The order can no longer be edited after it's closed",
                                  )}
                                  onConfirm={() =>
                                    this.updateTransferOrderStatus(
                                      "Partialy Closed",
                                    )
                                  }
                                  okText={t("Close")}
                                  cancelText={t("Close")}
                                >
                                  <Button
                                    type="danger"
                                    style={{ margin: "5px" }}
                                  >
                                    {t("Close")}
                                  </Button>
                                </Popconfirm>
                              )}
                              <Button
                                disabled={!hassPermissionToReceive}
                                type="primary"
                                style={{ margin: "5px" }}
                                onClick={() =>
                                  this.setState({ isReceiving: true })
                                }
                              >
                                {t("Receive Transfer")}
                              </Button>
                            </div>
                          )}
                        {isReceiving && (
                          <div>
                            <Popconfirm
                              title={t(
                                "Receiving this transfer order will update the stock",
                              )}
                              onConfirm={() =>
                                this.updateTransferOrderStatus("Received")
                              }
                              okText={t("Receive")}
                              cancelText={t("Close")}
                            >
                              <Button type="primary" style={{ margin: "5px" }}>
                                {t("Receive Fully")}
                              </Button>
                            </Popconfirm>
                            <Popconfirm
                              title={t(
                                "Receiving this transfer order will update the stock",
                              )}
                              onConfirm={() =>
                                this.updateTransferOrderStatus("Partial")
                              }
                              okText={t("Receive")}
                              cancelText={t("Close")}
                            >
                              <Button type="primary" style={{ margin: "5px" }}>
                                {t("Receive as typed")}
                              </Button>
                            </Popconfirm>
                          </div>
                        )}
                      </div>
                    )}
                </div>
              ) : (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    type="danger"
                    onClick={() => {
                      this.setState({
                        products: originalProducts,
                      });
                      this.setEditMode(false);
                    }}
                    style={{
                      margin: 5,
                    }}
                  >
                    {t("Cancel Updates")}
                  </Button>

                  <Button
                    type="primary"
                    onClick={() => this.updateTransferOrder()}
                    style={{ margin: "5px" }}
                  >
                    {t("Update")}
                  </Button>
                </div>
              )}
            </>
          ),
        ]}
      >
        {loading ? (
          <div className="my-5 text-center">
            <Spin indicator={antIcon} />
          </div>
        ) : (
          <TransferOrderInvoice
            selectedOrder={selectedOrder}
            isReceiving={isReceiving}
            setProducts={this.setProducts}
            editMode={editMode}
            setEditMode={this.setEditMode}
            setLoading={this.setLoading}
            products={products}
            isViewOnly={isViewOnly}
          />
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.auth.permissions,
    settings: state.auth.settings,
    config: state.config,
    is_staff: state.auth.is_staff,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces()(TransferOrderDetailsModal));
